const HELPER_INSTALLED_KEY = 'skyrover.helperInstalled';

export function wasHelperInstalledOnThisDevice(): boolean {
  try {
    return localStorage.getItem(HELPER_INSTALLED_KEY) === '1';
  } catch {
    return false;
  }
}

export function markHelperInstalledOnThisDevice(): void {
  try {
    localStorage.setItem(HELPER_INSTALLED_KEY, '1');
  } catch {
    // ignore storage errors
  }
}

/** Opens the local helper via custom URL protocol (registered by the Windows installer). */
export function tryLaunchHelperApp(): void {
  window.location.href = 'skyrover://helper/start';
}
